<template>
    <div class="adjustmentReport">
        <div class="content">
            <div class='adjustBox'>
                <p class='adjustTitle'>原规划内容</p>
                <PlanReport :plan="planLast" :version="version"></PlanReport>
            </div>
            <div class='adjustBox'>
                <p class='adjustTitle'>调整规划内容</p>
                <PlanReport :plan="plan" :version="version"></PlanReport>
            </div>
            <AdjustmentReport
                :targetCareer="adjustmentData.targetCareer"
                :university="adjustmentData.university"
                :further="adjustmentData.further"
                :choose="adjustmentData.choose"
                :version="version"
                :professional="professional"
            >
            </AdjustmentReport>
        </div>
        <div class="btnBox" style="display: flex;justify-content: space-around;padding: 45px 0px;width: 300px;margin: 0px auto;">
            <Button @handleClick="$router.go(-1)" :type="'btnGray'" name="返回" ></Button>
        </div>
    </div>
</template>
<script>
import Button from '@/components/Button.vue'
import PlanReport from '@/components/consultant/planningContent/PlanReport.vue'
import AdjustmentReport from '@/components/consultant/planningContent/AdjustmentReport.vue'
export default {
    name: "adjustmentReport",
    components: {
        Button,
        PlanReport,
        AdjustmentReport
    },
    data() {
        return {

            adjustmentData: {
                targetCareer:null,
                university:null,
                further:null,
                choose:null,
            },
            planReportTitle: '原规划内容',
            planLast:{},
            plan:{},
            version:'',
            professional:'',
        }
    },
    methods: {
        adjustPlanCompared(){
            let studentId = this.studentId;
            let oldId = this.$route.query.lastId;
            let newId = this.$route.query.id;
            this.$ajax.post(this.G_acapi + this.ports.student.student.planningContent.adjustPlanComparedByStudent,{
                studentId: studentId,
                oldId: oldId,
                newId:newId
            }, {
                headers: {
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res) => {
                let data = res.data;
                if (data.code == 2000) {
                    this.adjustmentData = res.data.data;
                    this.professional = res.data.data.targetCareer.professional
                    console.log(this.professional,'版本号学生')
                }
            })
        },
        getPlanById(id){
            let studentId = this.studentId;
            this.$ajax.post(this.G_acapi + this.ports.student.student.planningContent.getPlanByIdByStudent, {
                studentId: studentId,
                id: id
            }, {
                headers: {
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res) => {
                let data = res.data;
                if (data.code == 2000) {
                    this.plan = res.data.data;
                    this.version = res.data.data.version
                }
            })
        },
        getPlanByIdLast(id){
            let studentId = this.studentId;
            this.$ajax.post(this.G_acapi + this.ports.student.student.planningContent.getPlanByIdByStudent, {
                studentId: studentId,
                id: id
            }, {
                headers: {
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res) => {
                let data = res.data;
                if (data.code == 2000) {
                    this.planLast = res.data.data;
                }
            })
        },
    },
    created() {
        this.getPlanByIdLast(this.$route.query.lastId);
        this.getPlanById(this.$route.query.id);
        this.adjustPlanCompared();
    }
}
</script>

<style scoped lang="less">
.adjustmentReport {
    .content {
        padding: 25px 30px;
        background-color: #fff;
    }
    .adjustTitle {
        font-size: 22px;
        font-weight: 500;
        color: #12A1F0;
        line-height: 50px;
    }
}
</style>